import {
  Clock,
  Eye,
  Route,
  LayoutList,
  Hand,
  CheckCheck,
  ClipboardCheck,
  type LucideIcon,
} from 'lucide-react'

export interface Benefit {
  icon: LucideIcon
  title: string
  text: string
}

export const whyItems: Benefit[] = [
  {
    icon: Clock,
    title: 'Save preparation time',
    text: 'Start with structured material instead of rebuilding every class from zero.',
  },
  {
    icon: Eye,
    title: 'Teach more visually',
    text: 'Use diagrams, sequences, comparisons and placement maps to make techniques easier to explain.',
  },
  {
    icon: Route,
    title: 'Give students a clearer path',
    text: 'Move from demonstration to practice, correction and assessment with a system behind every class.',
  },
]

export const valueItems: Benefit[] = [
  {
    icon: LayoutList,
    title: 'Structure',
    text: 'Instead of wondering what to teach next, you have a progressive system to work from.',
  },
  {
    icon: Eye,
    title: 'Visual teaching',
    text: 'Instead of explaining everything verbally, you have visual references that support your demonstrations.',
  },
  {
    icon: Hand,
    title: 'Student practice',
    text: "Students don't just watch. They practice.",
  },
  {
    icon: CheckCheck,
    title: 'Correction',
    text: 'You have clearer ways to identify common errors and guide the retry.',
  },
  {
    icon: ClipboardCheck,
    title: 'Assessment',
    text: 'You can evaluate progress with more consistency instead of relying only on a general impression.',
  },
]

export const visualResources: string[] = [
  'Face maps',
  'Eye diagrams',
  'Lip maps',
  'Brow mapping',
  'Placement guides',
  'Step-by-step sequences',
  'Technique comparisons',
  'Before-and-corrected examples',
  'Color relationships',
  'Student practice activities',
  'Instructor correction tools',
  'Assessment systems',
  'Complete-look progressions',
]

export interface ExplainStep {
  word: string
  text: string
}

export const explainSteps: ExplainStep[] = [
  { word: 'Where', text: 'the product goes.' },
  { word: 'How', text: 'the technique is built.' },
  { word: 'What', text: 'students should observe.' },
  { word: 'Why', text: 'a result is not working.' },
  { word: 'How', text: 'to correct it.' },
]

export const teachingFormula: string[] = [
  'Explain',
  'Demonstrate',
  'Practice',
  'Correct',
  'Assess',
]
